import { TableField } from "../../table-field";

export const fieldsEventos: TableField[] = [
  {
    key: "IdEvento",
    label: "ID",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: "text-center",
    sortable: true,
  },
  {
    key: "DeTitulo",
    label: "Título",
    tdClass: ["align-middle", "quebrarPorPalavraHard"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
  },
  {
    key: "DeDescricao",
    label: "Descrição",
    tdClass: ["align-middle", "quebrarPorPalavra"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
  },
  {
    key: "DeTipoEvento",
    label: "Tipo de Evento",
    tdClass: ["align-middle", "quebrarPorPalavraHard"],
    thClass: ["text-center", "quebrarPorPalavraHard"],
    sortable: true,
  },
  {
    key: "actions",
    label: "Ações",
    tdClass: ["align-middle", "col-actions", "min15rem"],
    thClass: "text-center",
    sortable: false,
  },
];
